import React from "react";

export type MessageContextType = {
  resendLastQuery?: () => void;
};

export const MessageContext = React.createContext<MessageContextType>({});
